import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { XMLHttpRequestHandler_requestType } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";

import { vn_app_zone_notification } from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import { validationsList_template } from "../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/validationsList_template";
import { usersEdit_template } from "../components/templates/usersEdit_template";
import { vnApp_pubinsights } from "../components/vnApp_pubinsights";


declare var ko: any;
declare var page: any;
declare var Dropzone: any;

export class users_edit extends vnModule_knockoutJS{

    protected XHRHdl: XMLHttpRequestHandler;
    protected editForm: usersEdit_template;
    protected validationsList: validationsList_template;

    protected getModuleName(){
        return "users_edit";
    }

    buildContent() : Array<Element>{

        // create validation errors list template
        this.validationsList = new validationsList_template("validationList", this.viewModel, this);

        // create the users form
        this.editForm = new usersEdit_template("editForm", this.viewModel, this);

        return [this.validationsList.build(), this.editForm.build()];
    }

    fillPage() : void{

        this.getFormData();
    }

    protected saveEditUser(){

        this.save();
    }

    protected cancelEditUser(){

        this.releaseLock();

        // redirect to earnings page or user list
        this.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_WARNING, "User action canceled !");

        page.redirect('/users');
    }

    protected releaseLock(){

        // request a lock release
        let usrReq_url: string = '/api/user/release/lock/' + this.getVnAppZone().app.params.id + '/';
        let usrReq_params: Array<Array<string>> = [];
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.execute();
    }


    //
    // obtain the dynamic data required to fill the formulary
    protected getFormData(){

        this.loadingIn(this.editForm.builtTemplate);

        let id: number;
        let action: string;

        if( (id = this.getVnAppZone().app.params.id) && !isNaN(id)) {
            this.viewModel["editForm"].idUser(id);
        }

        let usrReq_url: string = '/api/user/dataWithLocker/' + id + "/";
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(this.viewModel["editForm"])] );
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetFormDataReturn;
        this.XHRHdl.execute();
    }
    //
    // use the form data to fill the form
    protected onGetFormDataReturn(req, obj){

        return function () {

            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);

                let appData = responseParsed.data;
                let user = responseParsed.data.user;

                let vnApp = obj.getVnAppZone().app;
                let loggedUserId = vnApp.loggedUser.user.id;

                obj.editForm.setPermissions(responseParsed.data.userPermissions);
                obj.editForm.setPersistentLoginSettings(appData.persistentLogin);

                obj.editForm.setupForm(vnApp_pubinsights, appData.roles, appData.brands, user.vnAppUser.roles, user.brands, loggedUserId, user);

                if(user.vnAppUser.id !== undefined && user.vnAppUser.id !== null){

                    obj.editForm.setSelectedBrands(user.brands);
                    obj.editForm.setSelectedRoles(user.vnAppUser.roles);
                    obj.updateElementForm(user, obj);
                }
                obj.generateDropzone(user.vnAppUser);
                obj.loadingOut(obj.editForm.builtTemplate);
                obj.validationsList.clearMessages();

            });
        }
    }

    protected updateElementForm(user, thisModule: users_edit){

        thisModule.viewModel["editForm"].idUser(user.id);
        thisModule.viewModel["editForm"].firstName(user.vnAppUser.firstName);
        thisModule.viewModel["editForm"].lastName(user.vnAppUser.lastName);
        thisModule.viewModel["editForm"].loginName(user.vnAppUser.loginName);
        thisModule.viewModel["editForm"].email(user.vnAppUser.email);
        thisModule.viewModel["editForm"].password("");
        thisModule.viewModel["editForm"].passwordConfirmation("");
        if (user.id != null){
            //if user already exists (not new)
            let vnApp = this.getVnAppZone().app;
            let userRoles: Array<number> = user.vnAppUser.roles;
            let idUser = vnApp.loggedUser.user.id;
        }

        let isActive:string = (user.isActive != null) ? (user.isActive).toString() : "1";
        thisModule.viewModel["editForm"].isActive(isActive);
    }

    protected generateDropzone(user){

        let myDropzone = new Dropzone("div#my-drop-zone", { url: "/api/user/uploadImage/", maxFiles: 1, acceptedFiles: "image/jpeg,image/png,image/gif"});

        let _this = this;

        /*myDropzone.on("complete", function(file) {
        });*/

        myDropzone.on("success", function(file, serverFileName) {
            let responseParsed = serverFileName;
            _this.viewModel["editForm"].pictureUrl(responseParsed.data);
        });
        myDropzone.on("addedfile", function(file) {
            if (this.files.length > 1) {
                this.removeFile(this.files[0]);
            }
        });

        if(user && user.pictureUrl){
            let mockFile = { name: user.pictureUrl, size: parseInt(user.pictureSize)};

            myDropzone.emit("addedfile", mockFile);
            myDropzone.createThumbnailFromUrl(mockFile, "/usersImages/" + mockFile.name);
            myDropzone.emit("complete", mockFile);
            myDropzone.files.push(mockFile);
            _this.viewModel["editForm"].pictureUrl(user.pictureUrl);
        }
    }

    protected save(){

        this.loadingIn(this.editForm.builtTemplate);

        let _this = this;
        let formReq_url: string = '/api/user/create';
        let formReq_params: Array<Array<string>> = [];

        let subViewModel = this.getSaveData();

        formReq_params.push(["data", ko.toJSON(subViewModel)] );

        let XHRHdl:XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url,formReq_params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction = (function(req, obj){

            return function () {

                obj.manageResponse(req, obj, function () {

                    let responseParsed = JSON.parse(req.request.response);

                    obj.releaseLock();

                    const warning = responseParsed.persistentLoginWarning;
                    obj.getVnAppZone().notification = new vn_app_zone_notification(
                        warning ? vn_app_zone_notification.TYPE_WARNING : vn_app_zone_notification.TYPE_SUCCESS,
                        warning || "User saved successfully !");
                    obj.validationsList.clearMessages();

                    page.redirect('/users');
                });
                obj.loadingOut(obj.editForm.builtTemplate);

            }
        });
        XHRHdl.execute();
    }

    protected getSaveData(){

        const data = JSON.parse(ko.toJSON(this.viewModel));
        const form = data.editForm;
        // Hidden controls must not reset an existing choice during an ordinary profile edit.
        if (form.canManageRememberMe !== true) {
            delete form.rememberMeAllowed;
            delete form.rememberMeCsrfToken;
        }
        delete form.canManageRememberMe;
        form.brands = null;
        form.roles = null;
        return data;
    }
}



// WEBPACK FOOTER //
// ./js/modules/users_edit.ts